import { Form, Formik } from "formik";
import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { Col, Row } from "reactstrap";

import BasicSelectOption from "components/common/Form/SelectOption/BasicSelectOption";
import { SimpleSubmitButton } from "components/common/SimpleSubmitBtn/SimpleSubmitButton";
import { useOptionUpdater } from "core/hooks/use-option-updater";
import { TGetAllStoreProductsData } from "core/models/store-products.model";
import { useGetAllStores } from "core/services/api/store.api";
import { AddToCartValidation } from "core/validations/cart-form-validation";
import { addToCart } from "store/slices/cart/cart.slice";

import Style from "./Style.module.scss";

interface IProps {
  product: TGetAllStoreProductsData;
}

const ProductStores: FC<IProps> = ({ product }) => {
  const dispatch = useDispatch();
  const getAllStores = useGetAllStores(product.id);

  const { options: stores } = useOptionUpdater(getAllStores, "id", "title");

  const onSubmit = (values: any) => {
    dispatch(addToCart({ product, storeProductId: values.storeProduct.value,storeProductTitle: values.storeProduct.label }));
  };

  return (
    <>
      <Formik
        initialValues={{ storeProduct: null }}
        onSubmit={onSubmit}
        validationSchema={AddToCartValidation}
      >
        {() => {
          return (
            <Form>
              <>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BasicSelectOption
                      name="storeProduct"
                      data={stores}
                      hasLabel
                      lableText="اتاق"
                      placeHolder="انتخاب کنید . . ."
                      isLoading={getAllStores.isLoading}
                    />
                  </Col>
                </Row>
                <SimpleSubmitButton
                  btnText="تائید"
                  isLoading={false}
                  type="submit"
                  className={`${Style.addButton} mx-auto mt-5`}
                />
              </>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export { ProductStores };
